module.exports = __webpack_public_path__ + "static/media/VanTabbertResume.ed8c9b96.pdf";